import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";
import card from "./card.png";

export const theMoneyMint = {
  id: "the-money-mint",
  name: "The Money Mint",
  
  colorScheme: {
    tileColors: [
      { background: "#00E676", text: "#fff" },  // very bright green
      { background: "#00C853", text: "#fff" },  // bright green
      { background: "#2E8B57", text: "#fff" },  // medium-dark green (sea green)
      { background: "#006400", text: "#fff" },  // dark green
    ],
    overlayPattern: overlay,
    overlayColor: "#004D00",  // keeping darker overlayColor (very dark green)
    scratchColor: "#228B22",  // keeping darker scratchColor (forest green)
    
    controlColor: "#2E7D32",  // keeping darker controlColor (dark green)
    onControlColor: "#fff",
  },
  
  nameImage: name,
  background: background,
  card: card,
} satisfies GameTheme;